export default "__VITE_ASSET__CXGDNLui__"